import { MDS_COLORS_INK_ACCENT, MDS_COLORS_INK_INVERSE, MDS_COLORS_INK_WEAK, MDS_COLORS_LINE_BORDER, } from '@rappi/mustache-b2b-foundations';
import { FlexContainer } from '@rappi/rests-commons-front';
import styled, { css } from 'styled-components';
export const StepWrapper = styled(FlexContainer) `
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 16px;
    width: 50%;
    height: 3px;
    transform: translateY(-50%);
  }

  &::before {
    left: 0;
    background: ${(p) => (!p.isFirst && p.status !== 'pending' ? MDS_COLORS_INK_ACCENT : MDS_COLORS_LINE_BORDER)};
  }

  &::after {
    right: 0;
    background: ${(p) => (!p.isLast && p.status === 'active' ? MDS_COLORS_INK_ACCENT : MDS_COLORS_LINE_BORDER)};
  }

  ${(p) => p.isFirst && `&::before { content: none; }`}
  ${(p) => p.isLast && `&::after { content: none; }`}
`;
export const StepCircle = styled.div `
  width: 32px;
  height: 32px;
  border-radius: 50%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  ${(props) => props.status === 'active' &&
    css `
      background: ${MDS_COLORS_INK_ACCENT};
      color: ${MDS_COLORS_INK_INVERSE};
    `}
  ${(props) => props.status === 'pending' &&
    css `
      background: ${MDS_COLORS_LINE_BORDER};
      color: ${MDS_COLORS_INK_WEAK};
    `}
`;
